import type { AllRouteEndpoints } from "../routeTypes";

export const offerfitAppGroupIdUseCasesUseCaseIdToken = "/offerfit/:app_group_id/use_cases/:use_case_id/token";

export const offerfitAppGroupIdUseCasesUseCaseIdTokenCacheKeys: AllRouteEndpoints[] = [];
